<template>
	<md-button class="md-simple md-just-icon md-primary" @click="doAction">
		<i v-if="iconStyleClass.includes('material')" :class="iconStyleClass">{{ iconClass }}</i>
		<i v-else :class="[iconStyleClass, iconClass]" />
	</md-button>
</template>

<script>

export default {
	computed: {
		iconStyleClass() {
			return this.params.iconStyleType ?? "fa";
		},
		iconClass() {
			return this.params.iconClass;
		},
		showIcon() {
			let checkShowIcon = this.params.checkShowIcon;
			if (checkShowIcon) {
				return checkShowIcon(this.params.data);
			} else {
				return true;
			}
		}
	},
    methods: {
        doAction() {
            this.params.action(this.params.data);
        }
    }
};
</script>
